export default "__VITE_ASSET__D3worc36__"